"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskValue = exports.demaskValue = exports.toSafeDecimalPlace = exports.clamp = exports.ensureNumber = exports.noop = void 0;
var currencyRegex = /\D\d\d$/;
var formatCurrency = function (value, locale, currency) {
    if (locale === void 0) { locale = 'en-US'; }
    if (currency === void 0) { currency = 'USD'; }
    var currencyValue = value.toLocaleString(locale, { currency: currency, style: 'currency' });
    if (currencyValue.endsWith('.00')) {
        return currencyValue.replace(currencyRegex, '');
    }
    return currencyValue;
};
var getDecimalCount = function (value) { return (value.toString().split('.')[1] || '').length; };
var roundToPlaceCount = function (value, roundTo) {
    var decimalPlaces = Math.pow(10, roundTo);
    return Math.round(value * decimalPlaces) / decimalPlaces;
};
var noop = function () {
    // no-op
};
exports.noop = noop;
var ensureNumber = function (value, defaultValue) {
    if (defaultValue === void 0) { defaultValue = 0; }
    return Number.isNaN(+value) ? defaultValue : +value;
};
exports.ensureNumber = ensureNumber;
var clamp = function (value, _a) {
    var min = _a[0], max = _a[1];
    return Math.min(max, Math.max(min, value));
};
exports.clamp = clamp;
var toSafeDecimalPlace = function (val, step) {
    var decimals = getDecimalCount(step);
    return roundToPlaceCount(val, decimals);
};
exports.toSafeDecimalPlace = toSafeDecimalPlace;
var demaskValue = function (formatted) { return Number(formatted.replace(/,|\$/g, '')); };
exports.demaskValue = demaskValue;
var maskValue = function (format) {
    if (format === void 0) { format = 'number'; }
    return function (value) {
        var safeNumber = (0, exports.ensureNumber)(value);
        if (format === 'number')
            return "".concat(safeNumber.toLocaleString('en'));
        if (format === 'years')
            return "".concat(Math.abs(Math.round(safeNumber)));
        return formatCurrency(safeNumber);
    };
};
exports.maskValue = maskValue;
